var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-icon",class:{'customer-icon__icon--border': _vm.border}},[_c('div',{staticClass:"customer-icon__icon"},[(_vm.hasValidImage)?_c('FCImage',{attrs:{"fc-provider":"storyblok","fc-modifiers":{
        isStatic: true,
      },"nuxt-image-props":{
        src: _vm.image.filename,
        alt: _vm.image.alt,
        width: '100',
        height: '100',
        sizes: 'xs:100px',
      }}}):_c('div',{staticClass:"customer-icon__fallback"},[_c('FontAwesomeIcon',{attrs:{"icon":['far', 'user']}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }